/**
 * Columna de conversación de zona (GEN-EKB-022b): la conversación con el agente que preside una zona,
 * en la columna derecha, sin sacar al usuario de la pantalla. El cuadro de escritura lo pone la zona (centro, abajo).
 *
 * Reutiliza ChatWindow en modo `columna` (misma lista de mensajes, indicadores y coste que el chat de siempre).
 * «Nueva conversación» ya no vive aquí: la pone el cuadro de escritura (GEN-EKB-022c), con la función `nueva` del hook.
 * Estilo del chat del Despacho (A-despacho-conversacion.html) al ancho de la columna; libro de estilo §2.
 */
import { ExternalLink, X } from 'lucide-react'
import { Avatar } from './ui.jsx'
import ChatWindow from '../components/ChatWindow.jsx'
import { useFotoAgente } from '../context/FotosAgentes.jsx'

export default function ColumnaConversacion({
  agente,            // { id, nombre, rol }: quien preside la zona
  chat,              // metadatos del chat (chat_id, titulo, iniciado…)
  esBorrador,
  envio,             // { texto, n }: siguiente mensaje a enviar
  ocupada = false,   // turno en curso
  onAbrirEnChats, onCerrar,
  onPrimerEnvio, onTurnoCerrado, onOcupado, onEnvioConsumido,
}) {
  const fotoDe = useFotoAgente()
  if (!agente || !chat) return null
  return (
    <aside className="dk-columna" aria-label={`Conversación con ${agente.nombre}`}>
      <header className="dk-columna__cab">
        <Avatar agente foto={fotoDe(agente)} iniciales={agente.nombre.charAt(0).toUpperCase()} nombre={agente.nombre} tamano={28} activo />
        <div className="dk-columna__quien">
          <b>Conversación con {agente.nombre}</b>
          {agente.rol && <small>{agente.rol}</small>}
        </div>
        <button type="button" className="dk-columna__btn" aria-label="Abrir en Chats" title="Abrir en Chats"
          onClick={onAbrirEnChats} disabled={esBorrador || ocupada}>
          <ExternalLink size={16} strokeWidth={1.8} aria-hidden="true" />
        </button>
        <button type="button" className="dk-columna__btn" aria-label="Cerrar conversación" title="Cerrar conversación" onClick={onCerrar}>
          <X size={16} strokeWidth={1.8} aria-hidden="true" />
        </button>
      </header>
      <div className="dk-columna__hilo">
        <ChatWindow
          key={chat.chat_id}
          columna
          chatId={chat.chat_id}
          chatMeta={chat}
          isDraft={esBorrador}
          envio={envio}
          onFirstSend={onPrimerEnvio}
          onTurnDone={onTurnoCerrado}
          onOcupado={onOcupado}
          onEnvioConsumido={onEnvioConsumido}
        />
      </div>
    </aside>
  )
}
